import type { RouteLocationNormalizedLoaded, RouteLocationRaw, Router } from 'vue-router';

type BackResolver = (to: RouteLocationNormalizedLoaded) => RouteLocationRaw;

const getBackTarget = (route: RouteLocationNormalizedLoaded): RouteLocationRaw | undefined => {
  const backTo = route.meta.backTo as RouteLocationRaw | BackResolver | undefined;
  if (!backTo) return undefined;
  if (typeof backTo === 'function') {
    return backTo(route);
  }
  return backTo;
};

export const goBackByRoute = (
  router: Router,
  route: RouteLocationNormalizedLoaded,
  fallback: RouteLocationRaw = { name: 'home' }
) => {
  const target = getBackTarget(route);
  if (target) {
    return router.replace(target);
  }

  if (window.history.length > 1) {
    router.back();
    return Promise.resolve();
  }

  return router.push(fallback);
};
